/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_ActionsInputs */

const en_recipe_actions = /** @type {(inputs: Recipe_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recipe actions`)
};

const de_recipe_actions = /** @type {(inputs: Recipe_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezept-Aktionen`)
};

/**
* | output |
* | --- |
* | "Recipe actions" |
*
* @param {Recipe_ActionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_actions = /** @type {((inputs?: Recipe_ActionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_ActionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_actions(inputs)
	return en_recipe_actions(inputs)
});